module.exports = __webpack_public_path__ + "img/shangbao.85894ae0.png";